// extracted by mini-css-extract-plugin
export default {"giftPointBody":"CustomerMessage_giftPointBody__M3pHO","okBtn":"CustomerMessage_okBtn__Z8cFi"};